import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { LoginTypes } from 'shared-library';
import { CookieService } from 'ngx-cookie-service';
import { Component, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { getAuthState } from '../../store/state/auth.states';
import { CoreSeoPages } from '@app/store/enums/core-seo-pages';
import * as AuthActions from '../../store/actions/auth.actions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StateStatuses } from '@app/store/enums/state-statuses.enum';
import { AuthDataForm } from '@app/store/models/auth-data.interface';
import { CoreService } from '@app/modules/core/services/core.service';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { FunctionsService } from '../../../core/services/functions.service';
import { SeoEventNames, SeoService } from '@app/modules/core/services/seo.service';
import { selectAuthState } from '@app/modules/auth/store/selectors/auth.selectors';

@Component({
  selector: 'app-auth-signin',
  templateUrl: './auth-signin.component.html',
  styleUrls: ['./../auth.global.scss', './auth-signin.component.scss']
})
export class AuthSigninComponent implements OnDestroy {

  session_info: SessionInfo
  login_form: FormGroup<AuthDataForm>
  private subscriptions: Subscription[] = []

  state_statuses = {
    FAILED: StateStatuses.FAILED,
    PENDING: StateStatuses.PENDING,
    SUCCESS: StateStatuses.SUCCESS,
    PROCESSING: StateStatuses.PROCESSING,
  }
  authState$ = this.store.select(selectAuthState);
  auth_types = {
    EMAIL: LoginTypes.EMAIL,
    GOOGLE: LoginTypes.GOOGLE,
    // FACEBOOK: LoginTypes.FACEBOOK,
  }

  constructor(
    private store: Store,
    private seo: SeoService,
    private formBuilder: FormBuilder,
    private coreService: CoreService,
    private cookieService: CookieService,
    public functionsService: FunctionsService
  ) {

    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
    this.subscriptions.push(
      this.authState$.subscribe(ls => {
        if (!this.login_form) {
          this.login_form = this.formBuilder.group({
            code: [ls.data.code],
            name: [ls.data.name],
            mobile: [ls.data.mobile],
            company: [ls.data.company],
            id_token: [ls.data.id_token],
            timezone: [ls.data.timezone],
            cpassword: [ls.data.cpassword],
            auth_type: [ls.data.auth_type],
            recaptcha_token: [ls.data.recaptcha_token],
            password_strength: [ls.data.password_strength],
            activating_ots_qr: [ls.data.activating_ots_qr],
            activation_code_ots_qr: [ls.data.activation_code_ots_qr],
            referral_id: [this.cookieService.get(environment.referral_cookie_key)],
            password: [ls.data.password, [!ls.data.id_token ? Validators.required : Validators.nullValidator]],
            email: [ls.data.email, [!ls.data.id_token ? Validators.required : Validators.nullValidator, Validators.email,]],
            otp: this.formBuilder.array(["", "", "", "", "", ""].map(otp => this.formBuilder.control(otp))),
          })
        }

        const value = ls.responses.login?.token_type === "otp"
        const urlControl = this.login_form.controls.otp;
        Object.keys(urlControl.controls).forEach(ucontrol => {
          if (value === true) {
            urlControl['controls'][ucontrol].setValidators([Validators.required]);
          } else {
            urlControl['controls'][ucontrol].clearValidators();
          }
          urlControl['controls'][ucontrol].updateValueAndValidity();
        });

      })
    )
    this.seo.generateMetaTags(CoreSeoPages.SIGN_IN)
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }

  async tryLogin() {
    // this.seo.eventEmitter(SeoEventNames.UserActions, "login", "loginButtonClick")

    if (!this.login_form.valid) {
      // this.seo.eventEmitter(SeoEventNames.UserActions, "login", "loginFormValidationFailed")
      return
    }

    if ((await getAuthState(this.store)).responses.login?.token_type !== "otp") {
      this.login_form.controls.otp.setValue(["", "", "", "", "", ""])
    }
    const data = this.login_form.value
    this.store.dispatch(AuthActions.login({
      data: {
        id_token: "",
        email: data.email,
        password: data.password,
        referral_id: data.referral_id,
        activating_ots_qr: data.activating_ots_qr,
        activation_code_ots_qr: data.activation_code_ots_qr,
        otp: data.otp.filter(otp => otp).join("").toUpperCase(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        recaptcha_token: await this.coreService.getRecaptchaToken(),
        login_type: !data.id_token ? LoginTypes.EMAIL : LoginTypes.GOOGLE,
      }
    }))
  }
}
